import React from 'react'
import { getCookieValue } from "./CommonFunctions";
const hideExistSign ={
    "display": 'none'
}
const showExistSign ={
    "display": 'block'
}
const SignIn = ({CallBack, isSignIn}) => {    
    let isSignInUser = document.cookie.indexOf("userinfo") > -1 ? true : false;  
    let isLoggedin  =  getCookieValue("loggedIn");
    console.log("Isloggen :"+ isLoggedin)
    if(isLoggedin != null){
        console.log("Isloggen1 :"+ isLoggedin)
        if(isLoggedin){isSignInUser = true;}
    }
    if(isSignIn ) {
    return(
        <section className="main w_signin large-mw-none" role="region">
            <div className="row">
                <div className="column tiny-12">
			        <div className="signin-text">
						<div className="display-table">
                            <div className="display-table-cell signin-icon">
                                {
                                  !isSignInUser && <img height="31" role="presentation"  src="/content/dam/verizon/support/consumer/supportservices/vcm-react/media/sign-in.png" width="31"/>
                                }
                                </div>
                                
                                <div className="display-table-cell vert-top padding-left-tiny " >
                                    {
                                    !isSignInUser && <div className="bold" style={{"marginTop":"0", "marginBottom":"1rem", "fontSize":"20px","line-height":" 20px"}} >Existing user?</div>
                                   }
                                   {
                                      !isSignInUser &&<div className="line-height-tiny">Sign in to manage & troubleshoot your services.</div>
                                   }
                                </div>
                              
                        </div>
                    </div>                   
                    <div className="signin-btn">
                        {
                       !isSignInUser && <button tabIndex="0" className="rounded-button" onClick={CallBack} data-track="Sign in">Sign in</button>
                       }
                    </div>
                   
                </div>
            </div>
        </section>
        )} else {
            return null
        }
        }

export default SignIn




// WEBPACK FOOTER //
// ./src/components/modules/Signin.js